import { Colors } from 'Components/Colors';
import { Text } from 'Components/Text/Text';
import { SALES_EMAIL_ADDRESS } from 'Config/HPSEmailAddresses';
import { AdvancedFeature, getDescriptionForAdvancedFeature } from 'Models/ClientDetailsModel';

export interface AdvancedFeatureUnavailableExplanationProps {
    feature: AdvancedFeature;
    reason: 'notGranted' | 'grantedButDisabled';
    textColor?: Colors;
}

export const AdvancedFeatureUnavailableExplanation = (props: AdvancedFeatureUnavailableExplanationProps) => {
    return (
        <>
            {props.reason === 'grantedButDisabled' ? (
                <Text color={props.textColor}>
                    Your organization has disabled <b>{props.feature}</b>. If you would like to use this feature, a SummIT administrator from your organization must enable it in Settings.
                </Text>
            ) : (
                <Text color={props.textColor}>
                    Your organization does not have access to {props.feature}. If you would like to enable this feature, contact <b>{SALES_EMAIL_ADDRESS}</b>.
                </Text>
            )}
            <Text noStyles color={props.textColor}>
                <b>Feature description: </b>
                {getDescriptionForAdvancedFeature(props.feature)}
            </Text>
        </>
    );
};
